import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    getAllOperationEntitiesForDropDown,
    getAllBuyersByFilter,
    saveBuyer,
    editBuyer

};

async function getAllBuyersByFilter(data) {

    let filter = {
        operationEntityID: parseInt(data.operationEntityID),
        businessRegNo: (data.businessRegNo == '' ? null : data.businessRegNo),
        groupID: parseInt(data.groupID)
    }

    const response = await CommonPost('/api/Buyer/GetBuyerByFilter', null, filter);
    return response.data;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function saveBuyer(data) {
    let buyer = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        country: data.country,
        buyerCode: data.buyerCode,
        buyerName: data.buyerName,
        buyerAddress: data.buyerAddress,
        businessRegNo: data.businessRegNo,
        billingAddress: data.billingAddress,
        contactPersonName: (data.contactPersonName == '' ? 'NULL' : data.contactPersonName),
        contactNumber: data.contactNumber,
        email: (data.email == '' ? 'NULL' : data.email),
        companyPhone: (data.companyPhone == '' ? 'NULL' : data.companyPhone),
        companyFax: (data.companyFax == '' ? 'NULL' : data.companyFax),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        creditPeriod: data.creditPeriod,
        creditAmount: parseFloat(data.creditAmount)
    }

    const response = await CommonPost('/api/Buyer/SaveBuyer', null, buyer);
    return response;
}

async function editBuyer(data) {
    let buyer = {
        buyerID: data.buyerID,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        country: data.country,
        buyerCode: data.buyerCode,
        buyerName: data.buyerName,
        buyerAddress: data.buyerAddress,
        businessRegNo: data.businessRegNo,
        billingAddress: data.billingAddress,
        contactPersonName: (data.contactPersonName == '' ? 'NULL' : data.contactPersonName),
        contactNumber: data.contactNumber,
        email: (data.email == '' ? 'NULL' : data.email),
        companyPhone: (data.companyPhone == '' ? 'NULL' : data.companyPhone),
        companyFax: (data.companyFax == '' ? 'NULL' : data.companyFax),
        isActive: data.isActive,
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        creditPeriod: data.creditPeriod,
        creditAmount: parseFloat(data.creditAmount)
    }

    const response = await CommonPost('/api/Buyer/editBuyer', null, buyer);
    return response;
}
